package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class SocialLoginClientRequestInfo(
    val email: String?,
    val facebookToken: String?,
    val googleToken: String?,
    val appleToken: String?,
    val reCaptchaToken: String?,
    val messageToken: String?
)